"use strict";

define('rs/form/attachment.document',['vertebrae'], function (Vertebrae) {
  var AttachmentDocument = Vertebrae.Object.extend({
    properties: ['id', 'fileType', 'fileName', 'displayName', 'activityDate', 'link', 'url', 'documentHash'],
    initialize: function initialize(options) {
      this.applyProperties(options);
      if (this.isUrl()) {
        this.setLink(true);
      }
      this._super.apply(this, arguments);
    },
    setFileName: function setFileName(name, silent) {
      this.setDisplayName.apply(this, arguments);
      return this._super.apply(this, arguments);
    },
    isUrl: function isUrl() {
      return !!this.getUrl();
    },
    toJSON: function toJSON() {
      return {
        id: this.getId(),
        fileType: this.getFileType(),
        fileName: this.getFileName(),
        displayName: this.getDisplayName(),
        activityDate: this.getActivityDate(),
        url: this.getUrl(),
        documentHash: this.getDocumentHash()
      };
    }
  }, {});
  return AttachmentDocument;
});

